export default class Allowances {
    constructor(allowances) {
        this.personal = allowances.personal;
        this.highEarnerThreshold = allowances.highEarnerThreshold;
        this.allowances = allowances.additional;
    }

    get blind() {
        return this.allowances.blind;
    }

    getAgeBandAllowance(age) {
        if (!Number.isInteger(age)) {
            return 0;
        }

        const ageBands = this.allowances.ageRelated.bands;
        let greatestAgeBand = 0;
        let allowance = 0;

        for (const band of ageBands) {
            if (age >= band.minAge && band.minAge >= greatestAgeBand) {
                allowance = band.allowance;
                greatestAgeBand = band.minAge;
            }
        }

        return allowance;
    }

    getAgeAllowanceThreshold() {
        return this.allowances.ageRelated.max;
    }

    getMarriageAllowanceMinAge() {
        return this.allowances.marriedCouple.minAge;
    }

    getMarriageAllowanceMin() {
        return this.allowances.marriedCouple.min;
    }

    getMarriageAllowanceMax() {
        return this.allowances.marriedCouple.max;
    }

    getMarriageAllowanceRate() {
        return this.allowances.marriedCouple.rate;
    }
}